import React from "react";

export const services = [
  {
    pillar: "Construction Layout",
    pillarKey: "construction",
    description:
      "Site control, stakeout, MEP layout, and as-builts executed to project datum with total stations, GNSS and laser plummets.",
    items: [
      {
        key: "construction_layout",
        title: "Site Control & Boundary Layout",
        body:
          "Establish boundaries with a location survey or tie into existing control. We set the vertical and horizontal datum used downstream for accurate stakeout and layout by every trade on site.",
        bullets: [
          "Horizontal & vertical control network",
          "Stakeout for foundations, footings & slabs",
          "Utility layout: poles, gas/water valves, hydrants, comms, sewers",
          "MEP (mechanical / electrical / plumbing) conduit layout",
        ],
      },
      {
        key: "as_built_survey",
        title: "As-Built Survey",
        body:
          "Documenting executed conditions periodically during development to verify the plans, and post-completion for final close-out documentation.",
        bullets: [
          "Periodic as-builts during construction",
          "Post-completion final documentation",
          "Interior dimensions survey for remodel scope (usable floor area)",
        ],
      },
      {
        key: "axis_column_layout",
        title: "Axis / Column Line Layout",
        body:
          "Lines set and labeled to project datum (0,0) on floor or wall to keep the building uniform floor to floor.",
        bullets: [
          "Core-hole (canhole) workflow with laser plummet / zenith-nadir",
          "Direct setup over control points for floor-to-floor transfer",
          "Elevations tied to project or NAVD88 datum",
          "Curtain wall / panel layout from EOC (edge of concrete) as-built",
        ],
      },
      {
        key: "tower_crane_plumbing",
        title: "Tower Crane Plumbing",
        body:
          "Vertical alignment during initial erection, jumping (climbing) and dismantling — verifying shim plates and anchor bolts are perfectly level.",
        bullets: [
          "Meet manufacturer tolerance (typically 1:500 or 1\" / 40 ft)",
          "Erect / jump / dismantle phase checks",
          "Prevent structural collapse & unsafe lift conditions",
        ],
      },
      {
        key: "optical_monitoring",
        title: "Optical Monitoring Survey",
        body:
          "Measuring settlement, tilt and deflection of structures and adjacent earthworks — including landmark protection in urban areas like NYC.",
        bullets: [
          "Structural & geotechnical monitoring",
          "Pre-construction baselines & landmark protection",
          "Excavation, shoring, slurry & retaining wall movement tracking",
        ],
      },
    ],
  },
  {
    pillar: "Rail Layout",
    pillarKey: "rail",
    description:
      "Alignment, geometry and catenary surveys for active rail corridors — pre-tamping, clearance gauging and foundation layout.",
    items: [
      {
        key: "rail_alignment",
        title: "Rail Alignment Surveys",
        body:
          "Reconnaissance, preliminary and final location surveys for route planning, plus track geometry and maintenance support.",
        bullets: [
          "Route planning: recon, preliminary & final location",
          "Outside as-built for pre-tamping, rail placement, clearance gauging",
          "Overhead line & pantograph alignment",
          "Inside as-built of platforms, running boards, rails, beams, columns, walls, fish plates",
        ],
      },
      {
        key: "catenary_survey",
        title: "Catenary Placement & Replacement",
        body:
          "Topographical, geometric, structural and geotechnical data for catenary systems — poles, gantries, bridges, foundations and soil.",
        bullets: [
          "Topographical & geometric data sets",
          "Structural: existing pole, gantry, bridge, foundation & soil",
          "Geotechnical test-pit / soak-away location layout",
          "CMP / caisson / sonotube layout, offsets, TOC, F1–F6 bolt-pack alignment, finished-can as-built",
        ],
      },
    ],
  },
  {
    pillar: "Conventional Land Surveying",
    pillarKey: "land",
    description:
      "Licensed boundary, topographical, ALTA/NSPS, architectural, title, air-rights and elevation certificate surveys.",
    items: [
      {
        key: "boundary_survey",
        title: "Boundary Survey",
        body:
          "Locates property lines, corners and boundaries to settle disputes, secure building permits, or install fencing.",
      },
      {
        key: "topographical_survey",
        title: "Topographical Survey",
        body:
          "Maps terrain, elevations, grades and existing natural or man-made features — crucial for grading and drainage design.",
      },
      {
        key: "alta_nsps_survey",
        title: "ALTA / NSPS Survey",
        body:
          "Highly detailed boundary survey meeting strict national standards. Property boundaries, improvements, visible easements, ROW, zoning, flood zones — plus Table A items (topo, parking, utility mapping). Required by most commercial lenders.",
      },
      {
        key: "architectural_survey",
        title: "Architectural Survey",
        body:
          "Detailed survey with elevations of all infrastructure (sewers, poles, hydrants, electrical/comms, manholes), utilities (gas/water valves, light poles, oil fills), decorative areas, centerline of road, top/bottom of curb, back of walk, lowest and highest points, first-floor and garage-floor elevations.",
      },
      {
        key: "title_survey",
        title: "Title Survey",
        body:
          "Simple survey often required by title companies or mortgage lenders at residential closing — relationships between house, primary structures and property lines, verifying no major zoning issues.",
      },
      {
        key: "air_rights_survey",
        title: "Air Rights & Elevation Certificate",
        body:
          "Air rights surveys and FEMA elevation certificate surveys for development, transfer of development rights and flood-zone compliance.",
      },
    ],
  },
];

export const droneCapabilities = [
  {
    key: "inspection",
    title: "Inspection",
    body:
      "Building façades, wind turbines, bridges, roof conditions, telecom towers and infrastructure visual inspection.",
  },
  {
    key: "mapping",
    title: "Mapping",
    body:
      "Corridor & route surveys, LiDAR, photogrammetry, thermal and multispectral mapping.",
  },
  {
    key: "aerial_doc",
    title: "Aerial Documentation",
    body:
      "Photogrammetry & videogrammetry, storm-damage assessment and analysis.",
  },
  {
    key: "thermal",
    title: "Thermal Analysis",
    body:
      "Solar farms, building envelope, heat-escape / retention and thermographic surveys.",
  },
  {
    key: "real_estate",
    title: "Commercial / Real Estate",
    body:
      "Marketing & promotional photo/video, 360° panoramic views, POI tours, future-view stills and video.",
  },
  {
    key: "construction_monitoring",
    title: "Construction Monitoring",
    body:
      "Cardinal-direction views, hyperlapse, asset management and uniformity tracking.",
  },
];
